import { VExpandTransition } from 'vuetify/lib/components/transitions';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VExpandTransition,[(_vm.links)?_c('Iframe',{staticClass:"fill-height fill-width",attrs:{"link":_vm.links.badgeUrl + 'login/forgot-password',"title":"Compte"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }